import styled from "styled-components";

export const RecommendationWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const RecommendationText = styled.span`
  font: normal normal normal 40px/55px BiNeo;
  letter-spacing: 0px;
  color: #8c8c8c;
  text-align: center;
  width: 200%;
`;

export const YellowSection = styled.div`
  height: 33%;
  background: #fdd26e 0% 0% no-repeat padding-box;
  border-radius: 20px;
  width: 100%;
  min-height: 15vh;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  @media only screen and (max-width: 680px) {
    min-height: 30vh;
  }
`;

export const YellowSectionTitle = styled.span`
  font: normal normal normal 2rem/55px BiNeo;
  letter-spacing: 0px;
  color: #003865;
`;

export const YellowSectionSubtitle = styled.span`
  letter-spacing: 0px;
  color: #003865;
`;

export const ResultContainer = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 10%;
`;

export const ResultTitle = styled.span`
  font: normal normal bold 56px/70px BiNeo;
  letter-spacing: 0px;
  color: #003865;
  text-decoration: underline;
  text-decoration-color: #ffb81c;
  text-underline-offset: 13px;
  text-align: center;
  @media only screen and (max-width: 680px) {
    margin-top: 2%;
  }
`;

export const ResultSubtitle = styled.span`
  font: normal normal bold 30px/30px BiNeo;
  letter-spacing: 0px;
  color: #003865;
  margin-top: 5%;
  text-align: center;
  @media only screen and (max-width: 680px) {
    margin-top: 10%;
  }
`;

export const ResultPhrase = styled.span`
  font: normal normal normal 24px/55px BiNeo;
  letter-spacing: 0px;
  color: #003865;
  text-align: center;
  @media only screen and (max-width: 680px) {
    margin-top: 10%;
  }
`;

export const StyledNextButton = styled.button`
  color: white;
  background: #2c8b9e 0% 0% no-repeat padding-box;
  border: 1px solid #2c8b9e;
  border-radius: 10px;
  height: 60px;
  margin-top: 2rem;
  &:hover {
    cursor: pointer;
    background-color: #003865;
    border: 1px solid #003865;
  }
  @media only screen and (min-width: 680px) {
    flex: 1;
    margin-top: 0;
  }
`;

export const StyledBackButton = styled.button`
  min-height: 60px;
  color: white;
  border: 1px solid #003865;
  border-radius: 10px;
  background-color: #003865;
  flex: ${(props) => (props.noFlex ? "none" : "1")};
  &:hover {
    background-color: #00c1d4;
    border: 1px solid #00c1d4;
    cursor: pointer;
  }
`;

export const StyledImage = styled.img`
  position: relative;
  max-height: 200px;
  @media only screen and (max-width: 780px) {
    position: relative;
    max-width: 100%;
  }
`;
